import { createApp } from 'vue';
import Toast from './Toast.vue';

const colors = ['success', 'info', 'error'];

const defaultOptions = {
  text: '',
  icon: '',
  color: 'info',
  timeout: 3000,
  dismissable: true
};

let toastCmp = null;

function createToastCmp() {
  // Use createApp to create the component instance
  const app = createApp(Toast);
  const cmp = app.mount(document.createElement('div'));

  document.body.appendChild(cmp.$el);

  return cmp;
}

function getToastCmp() {
  if (!toastCmp) {
    toastCmp = createToastCmp();
  }

  return toastCmp;
}

function show(options = {}) {
  getToastCmp().show({ ...options });
}

function close() {
  getToastCmp().close();
}

function createShorthands() {
  const shorthands = {};

  colors.forEach(
      color =>
          (shorthands[color] = (text, options = {}) =>
              show({ color, text, ...options }))
  );

  return shorthands;
}

export default {
  show,
  close,
  getToastCmp,
  defaultOptions,
  ...createShorthands()
};
